import script from "./CardSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardSlider.vue?vue&type=script&lang=ts&setup=true"

import "./CardSlider.vue?vue&type=style&index=0&id=51804020&lang=scss"

const __exports__ = script;

export default __exports__